import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/views/layout/LayOut.vue';


const routes = [
    {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
        {
        path: '/login',
        component: () => import('@/views/login/index.vue'),
        name: 'login',
        meta: { title: '登录'},
      },
        {
        path: '/register',
        component: () => import('@/views/register/index.vue'),
        name: 'register',
        meta: { title: '注册'},
      },
      {
        path: '/home',
        component: () => import('@/views/dashboard/index.vue'),
        name: 'home',
        meta: { title: '首页' },
      },
       {
        path: '/product',
        component: () => import('@/views/product/index.vue'),
        name: 'product',
        meta: { title: '产品'},
      },
      {
        path: '/productdetail',
        component: () => import('@/views/product/productdetail.vue'),
        name: 'productdetail',
        meta: { title: '产品详情'},
      },
       {
        path: '/newsCenter',
        component: () => import('@/views/newsCenter/index.vue'),
        name: 'newsCenter',
        meta: { title: '新闻中心'},
      },
      {
        path: '/article',
        component: () => import('@/views/article/index.vue'),
        name: 'article',
        meta: { title: '文章详情'},
      },
       {
        path: '/resource',
        component: () => import('@/views/resource/index.vue'),
        name: 'resource',
        meta: { title: '资源中心'},
      },
      {
        path: '/aboutUs',
        component: () => import('@/views/aboutUs/index.vue'),
        name: 'aboutUs',
        meta: { title: '关于我们'},
      },
       {
        path: '/materials',
        component: () => import('@/views/materials/index.vue'),
        name: 'materials',
        meta: { title: '资料下载'},
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
